import { render, staticRenderFns } from "./PlatformPhone.vue?vue&type=template&id=6e9c48a6&scoped=true&"
import script from "./PlatformPhone.vue?vue&type=script&lang=js&"
export * from "./PlatformPhone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9c48a6",
  null
  
)

component.options.__file = "PlatformPhone.vue"
export default component.exports